<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part_number"><span href="#/OEBPS/toc#p01" title="Link target outside of Sample">PART ONE</span></h1>
<h1 class="part_title"><span href="#/OEBPS/toc#p01" title="Link target outside of Sample">Ascension!</span></h1>
<div class="part">
<p class="center">‘To worship me take wine and strange drugs whereof I will tell my prophet, &amp; be drunk thereof!</p>
<p class="center">They shall not harm thee at all.’</p>
<p class="center1"><strong>– Aleister Crowley, <em>The Book of the Law</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?616b73a2